"use strict";

import { addEvent } from "./addEvent/addEvent";
import { isMobile } from "./isMobile/isMobile";
import { smoothScrollbarInit } from "./smoothScrollbar/smoothScrollbar";
import { mainMenuClass } from "./mainMenu/mainMenu";
import { videoInit } from "./videoBackground/videoBackground";
import { mainPageBanerInit } from "./mainPageBaner/mainPageBaner";
import { pageBaner } from "./pageBaner/pageBaner";
import {
  mousePosition,
  mousePositionElement,
} from "./mousePosition/mousePosition";
import { ajaxFormClass } from "./form/form";
import { showMoreInfo } from "./showMoreInfo/showMoreInfo";
import { lazyLoadImage } from "./lazyLoading/lazyLoading";
import { animationInIfVisible } from "./animationIn/animationInIfVisible";
import { changePageAnimationInit } from "./changePage/changePage";
import { goToFirstSection } from "./scrollToSection/scrollToFirstSection";
import { slideList } from "./slideList/slideList";

import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);

addEvent(window, "load", function () {
  afterLoadStart();
});

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

function DOMContentLoadedStart() {
  if (!isMobile() && !document.body.classList.contains("macos"))
    window.smoothScroll = smoothScrollbarInit({ damping: 0.1 });

  //if (!isMobile()) changePageAnimationInit();
  pageScroled();
  fullSiteMenuInit();
  forms();
  showMoreInfoInit();
  mainPageBanerInit();
  pageBanerInit();
  akceptacja_ciasteczka();
  powieksz_zdjecie();
  //if (!isMobile()) animationInInit();
  if (!isMobile()) backgroundParalax();

  // if (isMobile()) {
  //   $("body").addClass("mobile");
  // }
}

function afterLoadStart() {
  if (!isMobile()) mousePosition();
  if (!isMobile() && !document.body.classList.contains("macos"))
    mousePositionElement();
  videoInit();

  goToFirstSection();
  slideList(document.getElementsByClassName("slider-container"));

  lazyLoadImage(document.querySelectorAll("[data-images]"));
  addObserverToVideoInBaner();
}

function resize() {
  pageScroled();
}

function scroll() {
  pageScroled();
}

/*----- MAIN MENU -----*/
function fullSiteMenuInit() {
  window.fullSiteMenu = new mainMenuClass();
}

function animationInInit() {
  let elements = document.querySelectorAll(".animation-in-observer");
  animationInIfVisible({ elements, threshold: 0.1 });
}

function showMoreInfoInit() {
  const elements = document.getElementsByTagName("body");

  Array.from(elements).forEach((elm) => {
    new showMoreInfo({
      mainContainer: elm,
    });
  });
}

function forms() {
  let ajaxForms = $(".ajax-form");

  ajaxForms.each((idx, form) => {
    new ajaxFormClass(form);
  });
}

function pageBanerInit() {
  const elements = document.querySelectorAll(".page-baner-container");
  elements.forEach((element) => {
    new pageBaner(element);
  });
}

function powieksz_zdjecie() {
  powieksz_video();
  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

function powieksz_video() {
  const tab = $("a.inline-video");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.inline-video").colorbox({
      inline: true,
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function (e) {
        videoInit(
          document.getElementById("colorbox"),
          "colorbox-video-container"
        );
        //video[0].play();
        //video[0].controls = true;
        //video[0].loop = false;
      },
    });
  }
}

function akceptacja_ciasteczka() {
  $.post("/ciasteczka", { akceptacja: -1 }, function (data) {
    if (data == 1) {
      $("div.ciasteczka-info").hide();
    }
  });

  let elm = $(".akceptuje-ciasteczka");
  if (elm.length == 0) return;

  addEvent(elm[0], "click", (e) => {
    e.preventDefault();
    console.log("akceptuje-ciasteczka");
    $.post("/ciasteczka", { akceptacja: 1 });
    $("div.ciasteczka-info").fadeOut();
    return false;
  });
}

function pageScroled() {
  const className = "page-scrolled";
  const scrollBreakPoint = 10;

  let scroll = 0;

  if (window.smoothScroll) {
    window.smoothScroll.addListener(({ offset }) => {
      scroll = offset.y;

      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    });
  } else {
    scroll = $(window).scrollTop();

    if (scroll >= scrollBreakPoint) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }
}

function backgroundParalax() {
  const element = document.getElementById("baner-background");

  if (!window.smoothScroll || !element) return;

  window.smoothScroll.addListener(({ offset }) => {
    scroll = offset.y * 0.5;
    element.style.top = scroll + "px";
    element.style.bottom = "-" + scroll + "px";
  });
}

function addObserverToVideoInBaner(config = {}) {
  const { root, threshold } = config;

  const elementsContainer = document.getElementById("baner-background");
  if (!elementsContainer) return;

  const elementsVideo = elementsContainer.getElementsByTagName("video");
  if (elementsVideo.length == 0) return;

  const options = {
    root: root ? root : null,
    threshold: threshold ? threshold : 0.1,
    rootMargin: "10px",
  };

  const elements = [elementsContainer];

  if (!elements) {
    elements = [];
  }

  elements.forEach((element) => {
    const elementsVideo = elementsContainer.getElementsByTagName("video");
    if (elementsVideo[0]) elementsVideo[0].pause();
  });

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const elementsVideo = elementsContainer.getElementsByTagName("video");
        elementsVideo[0].play();
      } else {
        const elementsVideo = elementsContainer.getElementsByTagName("video");
        elementsVideo[0].pause();
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  elements.forEach((element) => {
    observer.observe(element);
  });
}
